var UrlService = /** @class */ (function () {
    function UrlService(envConfig) {
        this.envConfig = envConfig;
        this.environment = this.envConfig.callback(this.envConfig.value);
    }
    UrlService.prototype.checkTanByTanValue = function (tanValue) {
        return this.environment.classicServiceUrl + "api/public/tan/check-tan/" + tanValue;
    };
    UrlService.prototype.getBookingMappingByTanValueAndUsername = function (tanValue, username) {
        return this.environment.onsetServiceUrl + "api/booking-mapping?mapping-id=" + tanValue + "&context=GAST_LEGACY_TAN&username=" + username;
    };
    UrlService.prototype.createBookingMapping = function () {
        return this.environment.onsetServiceUrl + "api/booking-mapping";
    };
    return UrlService;
}());
export { UrlService };
